/* Becco AI Generator.
   The builder (shape / type / idea / style) lives INLINE in the section and is
   visible on the page. "Create my patches" opens a modal that handles only the
   results flow: loading -> (email gate) -> pick -> add-to-cart (online) or code (POS). */
(function () {
  'use strict';

  var DEVICE_KEY = 'bcc_device_id';

  // Horizon 4.x scrolls .page-wrapper (not the window) on desktop, so html overflow alone
  // doesn't stop the page behind the modal. Use the theme's own scroll lock as well.
  function lockPage(owner, lock) {
    import('@theme/utilities').then(function (u) {
      if (lock && u.lockScroll) u.lockScroll(owner);
      if (!lock && u.unlockScroll) u.unlockScroll(owner);
    }).catch(function () {});
  }
  var EMAIL_KEY = 'bcc_email';

  function deviceId() {
    var id = null;
    try { id = localStorage.getItem(DEVICE_KEY); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : 'd' + Date.now() + Math.random().toString(36).slice(2);
      try { localStorage.setItem(DEVICE_KEY, id); } catch (e) {}
    }
    return id;
  }
  function saveEmail(e) { try { localStorage.setItem(EMAIL_KEY, e); } catch (x) {} }
  function loadEmail() { try { return localStorage.getItem(EMAIL_KEY) || ''; } catch (x) { return ''; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function firstSentence(t) { if (!t) return ''; var m = String(t).split('.'); return m[0] ? m[0].trim() + '.' : ''; }

  function Generator(root) {
    var self = this;
    this.root = root;
    this.modal = root.querySelector('.bccg');
    this.worker = (root.dataset.worker || '').replace(/\/+$/, '');
    this.variantId = root.dataset.variant || '';
    this.mode = root.dataset.mode === 'pos' ? 'pos' : 'online';
    this.device = deviceId();
    this.st = { shapes: [], types: [], styles: [], shape: null, type: null, style: null, fields: {}, variations: [], selected: null, email: loadEmail() };
    this.$ = function (s) { return root.querySelector(s); };
    this.$all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    this._init();
    this.loadConfig();
  }

  Generator.prototype._init = function () {
    var self = this;
    this.$all('[data-bccg-close]').forEach(function (el) { el.addEventListener('click', function () { self.closeModal(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.modal && self.modal.classList.contains('is-open')) self.closeModal(); });

    var gen = this.$('[data-bccg-generate]'); if (gen) gen.addEventListener('click', function () { self.generate(); });
    var back = this.$('[data-bccg-back]'); if (back) back.addEventListener('click', function () { self.closeModal(); });
    var regen = this.$('[data-bccg-regenerate]'); if (regen) regen.addEventListener('click', function () { self.generate(); });
    var conf = this.$('[data-bccg-confirm]'); if (conf) {
      conf.textContent = this.mode === 'pos' ? 'Get my code →' : 'Add to cart →';
      conf.addEventListener('click', function () { self.confirm(); });
    }
    var es = this.$('[data-bccg-email-submit]'); if (es) es.addEventListener('click', function () { self.submitEmail(); });
  };

  /* ---- modal open/close (results only) ---- */
  Generator.prototype.openModal = function () {
    if (!this.modal) return;
    this.modal.hidden = false; this.modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    lockPage(this.modal, true);
  };
  Generator.prototype.closeModal = function () {
    if (!this.modal) return;
    this.modal.classList.remove('is-open'); this.modal.hidden = true;
    document.documentElement.style.overflow = '';
    lockPage(this.modal, false);
  };
  Generator.prototype.show = function (view) {
    this.$all('.bccg__view').forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-view') === view); });
  };
  Generator.prototype.err = function (sel, msg) { var e = this.$(sel); if (e) e.textContent = msg || ''; };

  /* playful cycling status while generating */
  Generator.prototype.startLoadMsgs = function () {
    var el = this.$('[data-bccg-loadmsg]'); if (!el) return;
    var msgs = ['Sketching your idea…', 'Mixing the colors…', 'Stitching the edges…', 'Adding the final touches…'];
    var i = 0; el.textContent = msgs[0]; this.stopLoadMsgs();
    this._loadTimer = setInterval(function () {
      i = (i + 1) % msgs.length;
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = msgs[i]; el.style.opacity = '1'; }, 260);
    }, 3200);
  };
  Generator.prototype.stopLoadMsgs = function () { if (this._loadTimer) { clearInterval(this._loadTimer); this._loadTimer = null; } };

  /* ---- config + inline builder ---- */
  Generator.prototype.loadConfig = function () {
    var self = this;
    fetch(this.worker + '/config').then(function (r) { return r.json(); }).then(function (cfg) {
      self.st.shapes = cfg.shapes || [];
      self.st.types = cfg.types || [];
      self.st.styles = cfg.styles || [];
      self.renderShapes(); self.renderTypes(); self.renderStyles();
    }).catch(function () { self.err('[data-bccg-error]', 'Could not load the designer. Please refresh.'); });
  };

  Generator.prototype.renderShapes = function () {
    var self = this, box = this.$('[data-bccg-shapes]'); if (!box) return;
    box.innerHTML = '';
    this.st.shapes.forEach(function (sh) {
      var g = sh.geometry_type === 'rectangle' ? 'rectangle' : (sh.geometry_type === 'oval' ? 'oval' : 'circle');
      var el = document.createElement('div');
      el.className = 'bccg__opt' + (self.st.shape && self.st.shape.id === sh.id ? ' is-selected' : '');
      el.innerHTML = '<span class="bccg__glyph bccg__glyph--' + g + '"></span>' +
        '<span class="bccg__opt-name">' + esc(sh.name) + '</span>' +
        '<span class="bccg__opt-sub">' + esc(sh.size || ((sh.width_in || '') + '" × ' + (sh.height_in || '') + '"')) + '</span>';
      el.addEventListener('click', function () { self.st.shape = sh; self.renderShapes(); self.validate(); });
      box.appendChild(el);
    });
  };

  Generator.prototype.renderTypes = function () {
    var self = this, box = this.$('[data-bccg-types]'); if (!box) return;
    box.innerHTML = '';
    this.st.types.forEach(function (t) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'bccg__chip' + (self.st.type && self.st.type.id === t.id ? ' is-selected' : '');
      el.textContent = t.name;
      el.addEventListener('click', function () { self.st.type = t; self.st.fields = {}; self.renderTypes(); self.renderFields(); self.validate(); });
      box.appendChild(el);
    });
    this.renderFields();
  };

  Generator.prototype.renderFields = function () {
    var self = this, box = this.$('[data-bccg-fields]'); if (!box) return;
    box.innerHTML = '';
    if (!this.st.type) return;
    (this.st.type.fields || []).forEach(function (f) {
      var wrap = document.createElement('div');
      var isLong = /desc|idea/.test(f.id) || (f.placeholder && f.placeholder.length > 40);
      var opt = f.required ? '' : ' (optional)';
      var control = isLong
        ? '<textarea class="bccg__textarea" maxlength="200" placeholder="' + esc(f.placeholder || '') + '"></textarea>'
        : '<input type="text" class="bccg__input" placeholder="' + esc(f.placeholder || '') + '">';
      wrap.innerHTML = '<label class="bccg__field-label">' + esc(f.label) + esc(opt) + '</label>' + control;
      var input = wrap.querySelector('input,textarea');
      input.addEventListener('input', function () { self.st.fields[f.id] = input.value; self.validate(); });
      box.appendChild(wrap);
    });
  };

  Generator.prototype.renderStyles = function () {
    var self = this, box = this.$('[data-bccg-styles]'); if (!box) return;
    box.innerHTML = '';
    this.st.styles.forEach(function (s) {
      var el = document.createElement('div');
      el.className = 'bccg__opt bccg__opt--style' + (self.st.style && self.st.style.id === s.id ? ' is-selected' : '');
      el.innerHTML = '<span class="bccg__style-name">' + esc(s.name) + '</span>' +
        '<span class="bccg__style-desc">' + esc(firstSentence(s.style_prompt)) + '</span>';
      el.addEventListener('click', function () { self.st.style = s; self.renderStyles(); self.validate(); });
      box.appendChild(el);
    });
  };

  Generator.prototype.validate = function () {
    var s = this.st, ok = s.shape && s.type && s.style;
    if (ok && s.type.fields) {
      ok = s.type.fields.filter(function (f) { return f.required; })
        .every(function (f) { return s.fields[f.id] && s.fields[f.id].trim(); });
    }
    var btn = this.$('[data-bccg-generate]'); if (btn) btn.disabled = !ok;
    return ok;
  };

  /* ---- generate (opens modal) ---- */
  Generator.prototype.generate = function () {
    var self = this;
    if (!this.validate()) return;
    this.err('[data-bccg-error]', '');
    this.openModal();
    this.show('loading');
    this.startLoadMsgs();
    fetch(this.worker + '/generate', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shape: this.st.shape.id, type: this.st.type.id, style: this.st.style.id,
        fields: this.st.fields, deviceId: this.device, email: this.st.email, mode: this.mode
      })
    }).then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); })
      .then(function (res) {
        self.stopLoadMsgs();
        var d = res.d;
        if (res.status === 403 || d.error === 'limit_reached') { self.showLimit(d.message); return; }
        if (d.needsEmail) { self.show('email'); self.err('[data-bccg-email-error]', ''); return; }
        if (!d.success || !d.variations || !d.variations.length) {
          self.closeModal(); self.err('[data-bccg-error]', d.message || d.error || 'Generation failed. Please try again.'); return;
        }
        self.st.variations = d.variations; self.st.selected = null;
        self.renderVariations(); self.show('pick');
      }).catch(function () { self.stopLoadMsgs(); self.closeModal(); self.err('[data-bccg-error]', 'Something went wrong. Please try again.'); });
  };

  Generator.prototype.submitEmail = function () {
    var input = this.$('[data-bccg-email]'); if (!input) return;
    var v = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) { this.err('[data-bccg-email-error]', 'Please enter a valid email.'); return; }
    this.st.email = v; saveEmail(v);
    this.generate();
  };

  Generator.prototype.renderVariations = function () {
    var self = this, box = this.$('[data-bccg-vars]'); if (!box) return;
    box.innerHTML = '';
    this.st.variations.forEach(function (v) {
      var el = document.createElement('div');
      el.className = 'bccg__var' + (self.st.selected && self.st.selected.r2Key === v.r2Key ? ' is-selected' : '');
      el.innerHTML = '<div class="bccg__var-img"><img src="' + esc(v.r2Url) + '" alt="' + esc(v.subtypeName) + '"></div>' +
        '<div class="bccg__var-name">' + esc(v.subtypeName) + '</div>';
      el.addEventListener('click', function () {
        self.st.selected = v; self.renderVariations();
        var c = self.$('[data-bccg-confirm]'); if (c) c.disabled = false;
      });
      box.appendChild(el);
    });
    var c = this.$('[data-bccg-confirm]'); if (c) c.disabled = !this.st.selected;
    this.err('[data-bccg-error2]', '');
  };

  Generator.prototype.confirm = function () {
    var self = this, sel = this.st.selected; if (!sel) return;
    if (this.mode === 'online' && !this.variantId) { this.err('[data-bccg-error2]', 'Product not configured yet.'); return; }
    var btn = this.$('[data-bccg-confirm]'); if (btn) { btn.disabled = true; btn.textContent = 'Working…'; }
    var userInput = Object.keys(this.st.fields).map(function (k) { return self.st.fields[k]; }).filter(Boolean).join(', ');

    fetch(this.worker + '/confirm', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        r2Key: sel.r2Key, shape: this.st.shape.id, style: this.st.style.id,
        subtypeId: sel.subtypeId, subtypeName: sel.subtypeName, type: this.st.type.id,
        userInput: userInput, assembledPrompt: sel.assembledPrompt, mode: this.mode
      })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d.success) throw new Error(d.error || 'confirm failed');
      var code = (d.order && d.order.id) || d.fileName;
      if (self.mode === 'pos') { self.showCode(code, d.r2Url); return; }
      return self.addToCart(d, userInput, code);
    }).catch(function () {
      self.err('[data-bccg-error2]', 'Something went wrong. Please try again.');
      if (btn) { btn.disabled = false; btn.textContent = self.mode === 'pos' ? 'Get my code →' : 'Add to cart →'; }
    });
  };

  Generator.prototype.addToCart = function (d, userInput, code) {
    var self = this, sel = this.st.selected;
    var props = { 'Shape': this.st.shape.name, 'Style': this.st.style.name, 'Design': sel.subtypeName,
      '_image_url': d.r2Url, '_r2_key': sel.r2Key, '_design_code': code };
    if (userInput) props['Your idea'] = userInput;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && res.j.description) || 'cart error');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        self.showAdded(d.r2Url);
      });
  };

  Generator.prototype.showAdded = function (img) {
    this.$('[data-bccg-done]').innerHTML =
      '<div class="bccg__done-img"><img src="' + esc(img) + '" alt="Your patch"></div>' +
      '<div class="bccg__big">Added to your cart</div>' +
      '<div class="bccg__muted">Custom AI patch · redirecting…</div>' +
      '<a class="bccg__btn bccg__btn--primary" style="margin:16px auto 0" href="/cart">Go to cart →</a>';
    this.show('done');
    setTimeout(function () { window.location.href = '/cart'; }, 1400);
  };

  Generator.prototype.showCode = function (code, img) {
    var self = this, done = this.$('[data-bccg-done]');
    done.innerHTML =
      '<div class="bccg__done-img"><img src="' + esc(img) + '" alt="Your patch"></div>' +
      '<div class="bccg__muted">Show this code at the counter</div>' +
      '<div class="bccg__code">' + esc(code) + '</div>' +
      '<div class="bccg__muted">Our team will print it for you</div>' +
      '<button class="bccg__btn" type="button" style="margin:18px auto 0" data-bccg-restart>Start over</button>';
    var rb = done.querySelector('[data-bccg-restart]');
    if (rb) rb.addEventListener('click', function () { self.reset(); });
    this.show('done');
  };

  Generator.prototype.showLimit = function (msg) {
    this.err('[data-bccg-limit-msg]', msg || "You've reached the maximum number of AI designs for now.");
    this.show('limit');
  };

  Generator.prototype.reset = function () {
    this.st.shape = null; this.st.type = null; this.st.style = null; this.st.fields = {};
    this.st.variations = []; this.st.selected = null;
    this.renderShapes(); this.renderTypes(); this.renderStyles(); this.validate();
    this.closeModal();
  };

  function boot() {
    document.querySelectorAll('[data-bccg]').forEach(function (root) {
      if (root.__bccg) return;
      root.__bccg = new Generator(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
